import { getModel as getModel2 } from '../../../services/api2.service';
import { IRankingListReturn } from '../interfaces/ranking';

/**
 * Get all rankings
 */
export const getAllRankings = async (query): Promise<IRankingListReturn> => {
    // Clean query for empty values

    Object.keys(query).forEach((key) => query[key] === undefined && delete query[key]);
    // Clean query for '' values
    Object.keys(query).forEach((key) => query[key] === '' && delete query[key]);
    // Create url params from query
    const urlParams = new URLSearchParams(query);
    //const params = urlParams.toString().replaceAll('%', ',');
    const urlModel = `rankings?${urlParams.toString()}`;
    const data = await getModel2(urlModel);
    return data;
};
